<div>
  <fieldset>
    <legend>Filter</legend>
    <input type="number" placeholder="Min"/>
    <input type="number" placeholder="Max"/>
  </fieldset>
  <fieldset>
    <legend>Sort</legend>
  </fieldset>
</div>
